import { useMemo } from 'react';

import { MonetizationEventsEventType } from '../../../dto/monetization-events.types';
import { resolveFlag, useFlag } from '../../../services/launchDarkly';
import { useStores } from '../../../stores/useStores';
import type { MonetizationWidgetDataType, WidgetEntry } from '../types';

export function useMonetizationWidgets() {
  const { sportEventsStore } = useStores();

  const monetizationEventsFF = useFlag('monetization_events_enabled', true);
  const crownSportsFeature = resolveFlag('crown_sports_feature', false);
  const { sportEvent } = sportEventsStore;

  const monetizationWidgets: MonetizationWidgetDataType[] = useMemo(() => {
    const monetizationEventsEnabled =
      monetizationEventsFF &&
      crownSportsFeature &&
      !!sportEvent &&
      sportEvent.providerType === MonetizationEventsEventType.SPORTS;
    if (monetizationEventsEnabled) {
      return [
        {
          key: sportEvent.id,
          type: 'monetization',
          event: sportEvent,
          dataTestId: `monetization-event-${sportEvent.gameNameType}-${sportEvent.id}-widget`,
        },
      ];
    }
    return [];
  }, [crownSportsFeature, monetizationEventsFF, sportEvent]);

  return useMemo(
    () =>
      monetizationWidgets.map((data): WidgetEntry<'monetization'> => ({ data, type: 'monetization', id: data.key })),
    [monetizationWidgets],
  );
}
